/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UsageCreate = {
    properties: {
        amount: {
            type: 'number',
            isRequired: true,
            format: 'float',
        },
        readDate: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
    },
};